import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { MedicalItemSubtypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemSubTypeEnum";
import { MedicalItemProblemAndCondition } from "@/Patient/Models/MedicalSummary/MedicalItemProblemAndCondition";

import styles from "./ActiveProblemAndConditionSection.module.css";

interface IActiveProblemAndConditionSectionProps {
    activeProblems: MedicalItemProblemAndCondition[];
    onMedicalItemClick: (model: MedicalItemProblemAndCondition, view: MedicalItemsTab) => void;
}

function ActiveProblemAndConditionSection(props: IActiveProblemAndConditionSectionProps): JSX.Element {
    return (
        <>
            {props.activeProblems?.map(activeProblem => (
                <a
                    key={activeProblem.EMRTemplateId + activeProblem.MedicalItemId}
                    onClick={() => props.onMedicalItemClick(activeProblem, MedicalItemsTab.MedicalProblem)}
                    data-cy="active-problem-and-condition-item"
                >
                    {getMedicalProblemsQualityDetailsRenderingElements(activeProblem)}
                    {getMedicalProblemsDescriptionAndProcedureRenderingElements(activeProblem)}
                </a>
            ))}
        </>
    );
}

function getMedicalProblemsQualityDetailsRenderingElements(activeProblem: MedicalItemProblemAndCondition): JSX.Element[] {
    const renderedElements: JSX.Element[] = [];
    let idx = 0;

    for (const qualifiedDetail of activeProblem.QualifiedDetails) {
        const lifeStageString = PatientMedicalSummaryHelper.GetLifeStageString(activeProblem, true);
        const statusString = (typeof qualifiedDetail.StatusLookupId !== "undefined" && qualifiedDetail.StatusLookupId !== null) ?
            "(" + cacheStore.GetLocalizedValueByLookupId(qualifiedDetail.StatusLookupId) + ")" :
            "";

        renderedElements.push(
            (
                <div className="flex-container" key={qualifiedDetail.Id}>
                    <div className={styles.status}>
                        {settingsStore.configuration.get("ShowDiagnosisCode") === true &&
                            <span>{qualifiedDetail.Code} - </span>
                        }
                        {(idx++ > 0) &&
                            <span> vs: </span>
                        }
                        <span>{qualifiedDetail.Text}</span>
                        <i> {statusString}</i>
                    </div>
                    <div className={styles.stage}>
                        <span>{lifeStageString}</span>
                    </div>
                </div>
            )
        );
    }

    return renderedElements;
}

function getMedicalProblemsDescriptionAndProcedureRenderingElements(activeProblem: MedicalItemProblemAndCondition): JSX.Element {
    const isClassifiedAsSurgeryHistory = activeProblem.EMRTemplateMedicalItemSubType != null &&
        activeProblem.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_SurgicalPast;
    const hasDescription = activeProblem.ProblemDescription != null && activeProblem.ProblemDescription.trim().length > 0;
    const hasProcedure = activeProblem.Procedure != null && activeProblem.Procedure.trim().length > 0;

    return (
        <>
            {((!isClassifiedAsSurgeryHistory && hasDescription) || !hasProcedure) && (
                <div className="active-problem-description-container text-gray">
                    {activeProblem.ProblemDescription}
                </div>
            )}

            {hasProcedure && (
                <div className="flex-container">
                    <div>
                        <span className="indent"> CH </span>
                        <span className="afterIndent"> {activeProblem.Procedure} </span>
                    </div>
                    <div className={styles.stage}>
                        <span> {PatientMedicalSummaryHelper.GetDateDisplayAccordingToPrecision(activeProblem.ProcedureDate, activeProblem.PrecisionDateProcedure)} </span>
                    </div>
                </div>
            )}
        </>
    );
}

export { ActiveProblemAndConditionSection };
